
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * BlockedIPReason enum
 */
class BlockedIPReason {
  /**
   * Initialize enum with a given value
   * @param {BlockedIPReason|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof BlockedIPReason) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!BlockedIPReason}
   * @param {!BlockedIPReason} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof BlockedIPReason)) {
      throw new TypeError('Instance of BlockedIPReason is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!BlockedIPReason}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!BlockedIPReason}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === BlockedIPReason.CONNECTION_RATE_EXCEEDED.value) {
      return 'CONNECTION_RATE_EXCEEDED'
    }
    if (this.value === BlockedIPReason.FAILED_LOGIN_RATE_EXCEEDED.value) {
      return 'FAILED_LOGIN_RATE_EXCEEDED'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!BlockedIPReason}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!BlockedIPReason}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!BlockedIPReason} Created enum
   */
  static fromObject (other) {
    return new BlockedIPReason(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
BlockedIPReason.CONNECTION_RATE_EXCEEDED = new BlockedIPReason(0 + 0)
// noinspection PointlessArithmeticExpressionJS
BlockedIPReason.FAILED_LOGIN_RATE_EXCEEDED = new BlockedIPReason(0 + 1)

export { BlockedIPReason };

/**
 * Fast Binary Encoding BlockedIPReason field model
 */
class FieldModelBlockedIPReason extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelBlockedIPReason}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelBlockedIPReason}
   * @param {BlockedIPReason=} defaults Default value, defaults is new BlockedIPReason()
   * @returns {!BlockedIPReason} Result value
   */
  get (defaults = new BlockedIPReason()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new BlockedIPReason(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelBlockedIPReason}
   * @param {!BlockedIPReason} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelBlockedIPReason };
